
    import {Options, Prop, Vue} from 'vue-property-decorator';

    @Options({})
    export default class TooltipsDescription extends Vue {
        @Prop({type: Number})
        pos!: number;
    }
